<h2 mat-dialog-title>Existing Parker Mass Update Results Exist</h2>
<mat-dialog-content class="mat-typography">
  <h4>Click continue to clear results from existing mass update and start a new update.</h4>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn btn-light btn-sm" 
        style="margin-right:10px;"
        [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
  <button class="btn btn-primary btn-sm ace-blue" 
          [mat-dialog-close]="true" cdkFocusInitial>Continue</button>
</mat-dialog-actions>
